module.exports = ['$rootScope', '$timeout', '$window', function ($rootScope, $timeout, $window) {
    return {
        restrict: 'E',
        scope: true,
        replace: true,
        controller: "OrderRequestsListCtrl",
        templateUrl: '/static/partials/order_requests_list.html',
        link: function ($scope, $element, attrs) {

        }
    };
}];